import React, { useState, useEffect } from 'react';
import { bool, func, string, shape } from 'prop-types';
import { createScopedTranslate } from '@airasia-common/libraries/i18n/LocaleHelper';
import Wrapper from '@airasia-common/react-dom/components/Wrapper/Wrapper';
import LoyaltyPointSearch from '@airasia-common/react-dom/components/LoyaltyPointSearch';
import BigMember from '@airasia-common/react-dom/components/BigMember';
import { useFlagRebrandEnabled } from '../../hooks/useFeatureFlag';

const translate = createScopedTranslate('guestDetails.bigMemberSearch');
const commonTranslate = createScopedTranslate('common');

const BigMemberSearchBar = props => {
  const {
    givenName,
    familyName,
    formName,
    requestSearch,
    memberId,
    isPayAtHotel,
  } = props;
  const [initialValue, setInitialValue] = useState('');
  const move = useFlagRebrandEnabled();
  const noteMsg = isPayAtHotel
    ? commonTranslate('payAtHotel.bigPointNoteMsg')
    : commonTranslate('payNow.bigPointNoteMsg');
  const onSearchClick = email => {
    if (!email) {
      return;
    }

    setInitialValue(email);
    requestSearch({
      email,
      givenName: givenName.value,
      familyName: familyName.value,
      formName,
    });
  };

  useEffect(() => {
    setInitialValue('');
    // the purpose it's to reset the member value when the name change to be able to search again
    // eslint-disable-next-line
  }, [givenName.value, familyName.value]);

  if (memberId.value !== null) {
    return (
      <Wrapper width={1} mt={[2, 4]} ml={[0, 2]} mb={[0, '20px']}>
        <BigMember {...memberId.value} />
      </Wrapper>
    );
  }

  const customError = memberId.failed
    ? translate(`errors.${memberId.error}`)
    : '';
  const hasValidName = [
    givenName.value,
    givenName.isValid,
    familyName.value,
    familyName.isValid,
    !memberId.fetching,
  ].every(Boolean);

  return (
    <LoyaltyPointSearch
      title={translate('title')}
      subtitle={translate('subtitle')}
      label={translate('label')}
      onSearchClick={onSearchClick}
      invalidError={translate('errors.invalid')}
      initialValue={initialValue}
      searchLabel={translate('searchLabel')}
      customError={customError}
      disabled={!hasValidName}
      isEnableNewBrandLogo={true}
      noteMsg={noteMsg}
      move={move}
    />
  );
};

const namePropType = {
  value: string,
  isValid: bool,
};
//
BigMemberSearchBar.propTypes = {
  givenName: shape(namePropType).isRequired,
  familyName: shape(namePropType).isRequired,
  memberId: shape({}).isRequired,
  formName: string.isRequired,
  requestSearch: func.isRequired,
  isPayAtHotel: bool,
};

export default BigMemberSearchBar;
